import { Injectable } from '@angular/core';
import { AccountModel } from '@domain/registration';
import { EncryptionService } from '@shared';

@Injectable({
	providedIn: 'root'
})
export class AccountStateService {
	protected formValues: AccountModel = {} as AccountModel;

	public constructor(protected encryptionService: EncryptionService) {}

	public setConnection(value: string): void {
		this.formValues.connectionId = value;
	}

	public setUsername(value: string): void {
		this.formValues.username = value;
	}

	public setPin(value: string) {
		this.formValues.pin = this.encryptionService.encrypt(value);
	}

	public getFormValues(): AccountModel {
		return this.formValues;
	}
}
